export default "__VITE_ASSET__DhgMi6dN__"